import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  Validators,
  FormGroup,
  AbstractControl,
} from "@angular/forms";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { LayoutService } from "src/app/shared/services/layout.service";
import { AuthService } from "../../shared/services/auth.service";
import { ConfigService } from "../../shared/services/config.service";
import { TranslateService } from "@ngx-translate/core";
import { faRotate, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  fontawesome = [
    {
      faRotate: faRotate,
      faEye: faEye,
      faEyeSlash: faEyeSlash,
    },
  ];

  public newUser = false;
  public loginForm: FormGroup;
  public show: boolean = false;
  public errorMessage: any;
  public showLanguageDropdown: boolean = false;

  // Language selection
  public selectedLanguage: any = {
    language: "Français",
    code: "fr",
    icon: "fr",
  };

  constructor(
    public layoutService: LayoutService,
    private router: Router,
    private auth: AuthService,
    private fb: FormBuilder,
    private httpClient: HttpClient,
    private spinner: NgxSpinnerService,
    private translateService: TranslateService,
    private configService: ConfigService
  ) {
    // Set default language to French
    this.translateService.setDefaultLang('fr');
    this.translateService.use('fr');
  }

  ngOnInit(): void {
    this.valitadion();
    this.captcha();
  }

  // Toggle language dropdown
  toggleLanguageDropdown() {
    this.showLanguageDropdown = !this.showLanguageDropdown;
  }

  // Language change method
  changeLanguage(langCode: string) {
    this.selectedLanguage = {
      code: langCode,
      language: langCode === 'fr' ? 'Français' : 'Türkçe',
      icon: langCode
    };
    this.translateService.use(langCode);
    localStorage.setItem('selectedLanguage', langCode);
    this.showLanguageDropdown = false; // Close dropdown after selection
  }

  captchaData!: string;
  password!: string;
  user!: string;
  captchaText!: any;
  key!: string;
  valitadion() {
    this.loginForm = this.fb.group({
      userName: ["", [Validators.required]],
      password: ["", [Validators.required]],
      recaptcha: ["", [Validators.required, Validators.minLength(4)]],
    });
  }
  get f(): { [key: string]: AbstractControl } {
    return this.loginForm.controls;
  }
  getCode!: string;
  async captcha() {
    this.spinner.show();
    const apiUrl = this.configService.getApiUrl();
    this.httpClient
      .get(`${apiUrl}/Auth/CaptchaUretici`)
      .subscribe(
        (res: any) => {
          this.captchaData = "data:image/png;base64," + res?.data.value;
          this.key = res?.data.key;
          this.spinner.hide();
        },
        (err) => {
          this.spinner.hide();
          console.error('❌ Captcha error:', err);
        }
      );
  }
  login() {
    let userData = {
      userName: this.user,
      password: this.password,
      captchaKey: this.key,
      captchaDeger: this.captchaData,
    };
    this.auth.signIn(userData, this.user);
  }

  showPassword() {
    this.show = !this.show;
  }
}
